import React from "react";
import CustomFetchFeedback from "../ui/CustomFetchFeedback/CustomFetchFeedback";
import PaymentInfoSkeleton from "../ui/Skeletons/PaymentInfoSkeleton";
import { usePaymentData } from "./components/hooks";
import PaymentPageContent from "./PaymentPageContent";

const PaymentPage = () => {
  const {
    mobileMoneyAccounts,
    bankAccounts,
    // walletAccounts,
    isLoading,
    isError,
    error,
    refetch,
  } = usePaymentData();

  if (isLoading) {
    return <PaymentInfoSkeleton />;
  }

  if (isError) {
    return (
      <CustomFetchFeedback
        error={error}
        onRetry={refetch}
        message="Failed to load payment accounts"
        fullHeight
      />
    );
  }

  return (
    <PaymentPageContent
      mobileMoneyAccounts={mobileMoneyAccounts}
      bankAccounts={bankAccounts}
    />
  );
};

export default PaymentPage;
